/* eslint-disable @typescript-eslint/return-await */
/* eslint-disable @typescript-eslint/await-thenable */
/* eslint-disable no-param-reassign */
import { MLink, errorMsg } from "@material-dev/insights-portal-ui-components";
import { isRejectedWithValue } from "@reduxjs/toolkit";
import { AnyAction, Dispatch, Middleware } from "redux";
import { InstructionValidationStatuses } from "app/ApiClient";
import {
  CreateCustomEmailNotificationCommand,
  EmailNotificationClient,
  IEmailNotificationClient,
} from "app/SharedApiClient";
import { BASE_SHARED_API_URL } from "const/baseUrl";
import { InstructionValidationException } from "types";
import { MAINTENANCE_TEAM_EMAIL } from "const/config";

const emailNotificationClient: IEmailNotificationClient = new EmailNotificationClient(BASE_SHARED_API_URL);

export const instructionValidationExceptionMiddleware: Middleware =
  () => (next: Dispatch<AnyAction>) => async (action: AnyAction) => {
    processInstructionValidationException(action);
    return await next(action);
  };

async function processInstructionValidationException(action: AnyAction) {
  if (isRejectedWithValue(action)) {
    if (action.payload) {
      if (InstructionValidationException.isInstructionValidationException(action.payload)) {
        const { dto } = action.payload;
        try {
          if (dto.validationStatus === InstructionValidationStatuses.Failed) {
            errorMsg(
              <>
                Something went wrong applying these modifications to the Data Lake. Please contact an&nbsp;
                <MLink
                  style={{ color: "white", textDecorationColor: "white" }}
                  href={`mailto:${MAINTENANCE_TEAM_EMAIL}`}>
                  Insights Portal Administrator
                </MLink>
                &nbsp;for further assistance.
              </>,
              {
                closeOnClick: true,
                autoHideDuration: 10000,
                anchorOrigin: { horizontal: "left", vertical: "top" },
              },
            );
            if (dto.createCustomEmailNotificationDto)
              await emailNotificationClient.sendCustomNotification({
                ...dto.createCustomEmailNotificationDto,
              } as CreateCustomEmailNotificationCommand);
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
  }
}
